<ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: linkLists }"></ng-container>

<ng-template #recursiveList let-linkLists>
  @for (linkList of linkLists; track linkList; let i = $index) {
    <div class="link-list__group">
      @if (linkList.links.length > 0) {
        <ng-container *ngTemplateOutlet="pageLinks; context: { $implicit: linkList.links, listIndex: i }"></ng-container>
      }
      @if (linkList.linkSections && linkList.linkSections.length > 0) {
        @for (section of linkList.linkSections; track section.title) {
          <button
            type="button"
            class="link-list__section"
            [ngClass]="{ 'cursor-default': !isNavigation }"
            [attr.aria-expanded]="false"
            (click)="onSectionClick($event)"
            (focusout)="onSectionFocusOut($event)"
            [attr.tabindex]="isNavigation ? 0 : -1"
          >
            <div class="link-list__section__item">
              @if (section.icon && section.icon !== '') {
                <i class="icon icon-{{ section.icon }}"></i>
              }
              <span class="link-list__section__title">{{ section.title }}</span>
            </div>
            <div class="link-list">
              <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: section.linkLists }"></ng-container>
            </div>
          </button>
        }
      }
    </div>
  }
</ng-template>

<ng-template #pageLinks let-links let-listIndex>
  <ul class="link-list__links">
    @for (link of links; track link.label) {
      <li class="link-list__links__item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <a [airLink]="link" [userEventSource]="userEventSource" tabindex="0">
          <span>{{ link.label }}</span>
          @if (link.icon && link.icon !== '') {
            <i class="icon icon-{{ link.icon }}"></i>
          }
        </a>
      </li>
    }
  </ul>
</ng-template>
